import { rgba } from 'polished'

import { width, padding } from 'common.styles'

export const rootStyle = (theme) => {
  const { paper, default: bgColor } = theme.palette.background
  const { black } = theme.palette.common
  const { borderRadius } = theme.shape

  return {
    ...padding(7.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    backgroundImage: `linear-gradient(to top, ${bgColor} 0%, ${paper} 100%)`,
    boxShadow: `0 -16px 32px ${rgba(black, 0.025)}`,
    borderRadius: {
      xs: `${3 * borderRadius}px ${3 * borderRadius}px 0 0`,
      md: `${4 * borderRadius}px ${4 * borderRadius}px 0 0`,
    }
  }
}

export const titleStyle = () => ({
  marginBottom: 3
})

export const textStyle = () => ({
  ...width('60%', '40%'),
  fontStyle: 'italic'
})

export const socialStyle = () => ({
  marginTop: 3
})

export const linksStyle = theme => ({
  marginTop: 3,
  '& a': {
    fontWeight: 'fontWeightMedium',
    textDecoration: `underline ${theme.palette.divider} !important`,
  },
  '& a + a:before': {
    display: 'inline-block',
    content: '"•"',
    marginInline: '1ch',
    color: 'text.disabled'
  }
})

export const linksCaptionStyle = () => ({
  marginBottom: 0.5
})
